import React, { useCallback, useMemo } from 'react';
import DT from 'duration-time-conversion';
import cn from 'classnames';
import { parseTime } from '../../../../../../shared/utils';
import Logger from '../../../../../../services/Logger';
import s from '../Markers.module.scss';

const ActionsMarkers = ({
  data, handleLeftStickyMarker, handleRightStickyMarker, handleCommentMarker, setCurrentTime, assetId,
}) => {
  /** We need to combine markers with the same startTime */
  const preparedData = useMemo(() => {
    const combinedMarkers = {};
    data.forEach((action, index) => {
      const { startTime } = action;
      if (!combinedMarkers[startTime]) {
        combinedMarkers[startTime] = [];
      }
      combinedMarkers[startTime].push({ index, ...action });
    });
    return Object.values(combinedMarkers);
  }, [data]);

  const handleClick = useCallback((startTime, value) => () => {
    const time = DT.t2d(startTime);
    Logger.log('User', 'PreviewTimelineActionsTimeCodeClicked', {
      assetId,
      timestamp_sec: time,
      entity_value: value,
    });
    setCurrentTime(time);
  }, [assetId, setCurrentTime]);

  return preparedData.map((ac) => (
    <div
      key={ac[0].index}
      className={cn(s.itemMarker, {
        [s.leftStickyMarker]: handleLeftStickyMarker(ac[0], 'startTime'),
        [s.rightStickyMarker]: handleRightStickyMarker(ac[0], 'startTime'),
      })}
      style={{ left: `${handleCommentMarker(ac[0], 'startTime')}%` }}
      role="presentation"
      onClick={handleClick(ac[0].startTime, ac.map((item) => item?.text).join(' | '))}
    >
      <div className={s.itemMarkerData}>
        {ac.map((item) => (
          <div key={item.index} className={s.itemMarkerDataText}>
            <div className={s.itemMarkerDataTitle}>Action {item.markerOrder || item.index + 1} {' '}
              <span className={s.itemMarkerDataTextTime}>
                ({parseTime(DT.t2d(item.startTime))}
                <If condition={item.endTime}>
                  {' '}- {parseTime(DT.t2d(item.endTime))}
                </If>
                )
              </span>
            </div>
            {item.text}
          </div>
        ))}
      </div>
    </div>
  ));
};
export default ActionsMarkers;
